export var MissionType;
(function (MissionType) {
    MissionType[MissionType["Combat"] = 0] = "Combat";
    MissionType[MissionType["Mining"] = 1] = "Mining";
    MissionType[MissionType["Exploration"] = 2] = "Exploration";
    MissionType[MissionType["Delivery"] = 3] = "Delivery";
    MissionType[MissionType["Escort"] = 4] = "Escort";
    MissionType[MissionType["BountyHunt"] = 5] = "BountyHunt";
    MissionType[MissionType["Salvage"] = 6] = "Salvage";
    /**
     * Surface-only "defend the dig" objective. Generated by stations on
     * planet surfaces when the surface has at least one ruin / dig site
     * (Phase 2.1). The objective accumulates real elapsed time (in ms)
     * while the player stays within the radius of the assigned site. The
     * pirate wave the planet auto-spawns near the site is what makes the
     * objective interesting; the wave is part of normal NPC behaviour
     * and runs through the same combat / parity rules as everything else.
     */
    MissionType[MissionType["Excavation"] = 7] = "Excavation";
    /**
     * Capstone "Liberate the World" meta-mission for pirate-tagged
     * surfaces (Phase 3.3). Single objective: defeat every hostile NPC
     * the surface generator spawned. Reward is a large XP + credits
     * stipend, a permanent codex liberation badge, and a flag on the
     * pilot's `liberatedSurfaces` set. The mission is auto-offered at
     * the Spaceport on first dock; once completed, the planet stops
     * generating it for that pilot.
     */
    MissionType[MissionType["Liberate"] = 8] = "Liberate";
})(MissionType || (MissionType = {}));
export var ObjectiveType;
(function (ObjectiveType) {
    ObjectiveType[ObjectiveType["Kill"] = 0] = "Kill";
    ObjectiveType[ObjectiveType["Mine"] = 1] = "Mine";
    ObjectiveType[ObjectiveType["Visit"] = 2] = "Visit";
    ObjectiveType[ObjectiveType["Deliver"] = 3] = "Deliver";
    ObjectiveType[ObjectiveType["Collect"] = 4] = "Collect";
    ObjectiveType[ObjectiveType["Survive"] = 5] = "Survive";
    ObjectiveType[ObjectiveType["Scan"] = 6] = "Scan";
    /**
     * Hold position inside an excavation site. `required` is the total
     * defend duration in MILLISECONDS, `current` accumulates the same
     * unit from server-emitted `excavate` events (each event carries a
     * `amount` = ms delta). Decoupled from `Survive` because Survive's
     * implementation expects a continuous timer regardless of position;
     * Excavate requires the player to actually be at the dig site.
     */
    ObjectiveType[ObjectiveType["Excavate"] = 7] = "Excavate";
    /**
     * Phase 3.3 — count hostile-NPC kills on a specific pirate world.
     * `required` is the initial hostile NPC count from the blueprint;
     * each `liberate` mission event with a matching `target` (surface
     * id) increments `current` by 1. Decoupled from {@link Kill} so
     * the Liberate arc can scale on per-surface count without being
     * polluted by global "kill 20 enemies" trackers.
     */
    ObjectiveType[ObjectiveType["Liberate"] = 8] = "Liberate";
})(ObjectiveType || (ObjectiveType = {}));
//# sourceMappingURL=missions.js.map